const ITEM_TRANSITION_DURATION_MS = 200;
const ITEM_TRANSITION_DELAY_MS = 75;
const snackbarCls = "_61s1l2h7n4";
const transitionCls = "_61t112hgzf";

export { ITEM_TRANSITION_DELAY_MS, ITEM_TRANSITION_DURATION_MS, snackbarCls, transitionCls };
import "./Snackbar.style.linaria.module.css";
//# sourceMappingURL=Snackbar.style.js.map
